export default __webpack_public_path__ + "static/media/corbeille.3c2c6165.svg";